import { c as _c } from "react/compiler-runtime";
import classNames from "classnames";
import { CmsImageForUrl } from 'src/components/images/CmsImageForUrl';
import cssPosterStyles from "src/components/posterrow/CSSPoster.module.css";
import PlaySvg from 'src/components/svg/PlaySvg';
import type { MovieClip } from 'src/lib/movieinfo/movieinfotypes';
import styles from "./TrailerPoster.module.css";

//#region [Props]
type TrailerPosterProps = {
  movieClip: MovieClip;
  className?: string;
};
//#endregion

//#region [Component]
export default function TrailerPoster(t0) {
  const $ = _c(21);
  const {
    movieClip,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(className, cssPosterStyles.CSSPoster, styles.SArticle);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className) {
    t2 = classNames(className, cssPosterStyles.CSSPosterWrapper, cssPosterStyles.CSSPosterMissing);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `#trailer${movieClip.id}`;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PlaySvg className={styles.SPlaySvg} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `Plakat for ${movieClip.movieTitle}`;
  let t6;
  if ($[5] !== movieClip.sanityImagePosterUrl || $[6] !== t5) {
    t6 = <CmsImageForUrl imageUrl={movieClip.sanityImagePosterUrl} alt={t5} width={227} unoptimized={true} isPosterAspect={true} />;
    $[5] = movieClip.sanityImagePosterUrl;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <a className={cssPosterStyles.CSSPosterSizer} href={t3}>{t4}{t6}</a>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t7) {
    t8 = <div className={t2}>{t7}</div>;
    $[11] = t2;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = `#trailer${movieClip.id}`;
  let t10;
  if ($[14] !== movieClip.movieTitle || $[15] !== t9) {
    t10 = <h2 className={cssPosterStyles.H}><a href={t9}>{movieClip.movieTitle}</a></h2>;
    $[14] = movieClip.movieTitle;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t1 || $[18] !== t10 || $[19] !== t8) {
    t11 = <article className={t1}>{t8}{t10}</article>;
    $[17] = t1;
    $[18] = t10;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
//#endregion